export default __webpack_public_path__ + "static/media/price-label.f30c1a05.svg";